import React from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useMutation } from "react-query";
import { useAppContext } from "../context/appContext";
import { Mixpanel } from "../utils/Mixpanel";
import TokenService from "../utils/TokenService";
import MainMenu from "../components/MainMenu";
import authApi from "../service/IdApi";
import { useSearchParams } from "react-router-dom";
import validator from "validator";
import { Password } from "primereact/password";
import { throttle } from "lodash";

const initialState = {
    email: ""
};

const ForgotPassword = () => {
    const { displayAlert } = useAppContext();
    const navigate = useNavigate();
    const [values, setValues] = useState(initialState);
    const [mobileTopbarActive] = useState(false);
    const [changesMadeEmail, setChangesMadeEmail] = useState(false);
    const [changesMadePassword, setChangesMadePassword] = useState(false);
    const [inputPassword, setInputPassword] = useState("");
    const [searchParams, setSearchParams] = useSearchParams();
    const [isProcessing, setIsProcessing] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [code, setCode] = useState("");
    const [codeVerified, setCodeVerified] = useState(false);
    const [pwdLenghtMet, setPwdLenghtMet] = useState(false);
    const [pwdSpecialMet, setPwdSpecialMet] = useState(false);
    const [pwdLowercaseMet, setPwdLowercaseMet] = useState(false);
    const [pwdUppercaseMet, setPwdUppercaseMet] = useState(false);
    const [pwdNumberMet, setPwdNumberMet] = useState(false);

    const handleChange = (e) => {
        setChangesMadeEmail(true);
        setValues({ ...values, [e.target.name]: e.target.value });
    };

    const handlePasswordChange = (e) => {
        var _pwd = e.target.value;
        setInputPassword(_pwd);
        if (_pwd.length > 11) {
            setPwdLenghtMet(true);
        }
        else {
            setPwdLenghtMet(false);
        }
        var uppercaseRegex = /[A-Z]/;
        var hasUppercase = uppercaseRegex.test(_pwd);
        if (hasUppercase) {
            setPwdUppercaseMet(true);
        }
        else {
            setPwdUppercaseMet(false);
        }
        var lowercaseRegex = /[a-z]/;
        var hasLowercase = lowercaseRegex.test(_pwd);
        if (hasLowercase) {
            setPwdLowercaseMet(true);
        }
        else {
            setPwdLowercaseMet(false);
        }
        var specialRegex = /[!@#$%^&*()_+,.?;:{}|<>/\-]/;
        var hasSpecial = specialRegex.test(_pwd);
        if (hasSpecial) {
            setPwdSpecialMet(true);
        }
        else {
            setPwdSpecialMet(false);
        }
        var numberRegex = /[0-9]/;
        var hasNumber = numberRegex.test(_pwd);
        if (hasNumber) {
            setPwdNumberMet(true);
        }
        else {
            setPwdNumberMet(false);
        }
        setChangesMadePassword(true);
    };

    const forgotPasswordApi = useMutation((values) => {
        try {
            const data = authApi.post("auth/forgot-password", values).then((response) => response.data);
            return data;
        } catch (error) {
            throw error;
        }
    });

    const resetPasswordApi = useMutation((values) => {
        const requestBody = {
            code: code,
            password: inputPassword
        };
        try {
            const data = authApi.post("auth/reset-password", requestBody).then((response) => response.data);
            return data;
        } catch (error) {
            throw error;
        }
    });

    const onResetPasswordSubmit = (e) => {
        e.preventDefault();
        submitAction();
    }

    const submitAction = throttle(() => {
        setIsProcessing(true);
        if (!validator.isStrongPassword(inputPassword, {
            minLength: 12,
            minLowercase: 1,
            minUppercase: 1,
            minNumbers: 1,
            minSymbols: 1,
        })) {
            if (inputPassword.length < 12) {
                displayAlert("error", "Error", "Password must be at least 12 characters");
                Mixpanel.track("UI Forgot Password - failed password validation length");
            }
            else {
                var uppercaseRegex = /[A-Z]/;
                var hasUppercase = uppercaseRegex.test(inputPassword);
                if (!hasUppercase) {
                    displayAlert("error", "Error", "Password must contain one uppercase letter");
                    Mixpanel.track("UI Forgot Password - failed password validation uppercase letter");
                }
                else {
                    var lowercaseRegex = /[a-z]/;
                    var hasLowercase = lowercaseRegex.test(inputPassword);
                    if (!hasLowercase) {
                        displayAlert("error", "Error", "Password must contain one lowercase letter");
                        Mixpanel.track("UI Forgot Password - failed password validation lowercase letter");
                    }
                    else {
                        var specialRegex = /[!@#$%^&*()_+,.?;:{}|<>/\-]/;
                        var hasSpecial = specialRegex.test(inputPassword);
                        if (!hasSpecial) {
                            displayAlert("error", "Error", "Password must contain one special character");
                            Mixpanel.track("UI Forgot Password - failed password validation special character");
                        }
                        else {
                            var numberRegex = /[0-9]/;
                            var hasNumber = numberRegex.test(inputPassword);
                            if (!hasNumber) {
                                displayAlert("error", "Error", "Password must contain one number");
                                Mixpanel.track("UI Forgot Password - failed password validation number");
                            }
                            else {
                                // TODO we shouldn't get here assuming our validation is correct.
                                displayAlert(
                                    "error",
                                    "Error",
                                    "Password must be 12 characters with at least 1 uppercase, 1 lowercase, 1 digit, and 1 special character"
                                );
                                Mixpanel.track("UI Forgot Password - failed password validation");
                            }
                        }
                    }
                }
            }
            return;
        }
        resetPasswordApi.mutate(values, {
            onError: (error, variables, context) => {
                if (error.response.status === 404) {
                    displayAlert("error", "Unexpected Error", "Invalid token. Please contact support@wallist.com.");
                    Mixpanel.track("UI Forgot Password Reset - failed email not found");
                }
                else {
                    displayAlert("error", "Unexpected Error", "Please try again later");
                    Mixpanel.track("UI Forgot Password Reset - failed API error");
                }
                setIsProcessing(false);
            },
            onSuccess: (data) => {
                displayAlert("success", "Success", "Password reset successfully.");
                Mixpanel.track("UI Forgot Password Reset - successful");
                setIsProcessing(false);
                window.location.href = process.env.REACT_APP_ID_SITE + "/login";
                return;
            },
        });
    }, 500, { trailing: false });

    const onEmailSubmit = (e) => {
        e.preventDefault();
        emailSubmitAction();
    }

    const emailSubmitAction = throttle(() => {
        setIsProcessing(true);
        if (!validator.isEmail(values.email)) {
            displayAlert("error", "Error", "Please enter a valid email address");
            Mixpanel.track("UI Forgot Password - failed email validation");
            setIsProcessing(false);
            return;
        }

        forgotPasswordApi.mutate(values, {
            onError: (error, variables, context) => {
                if (error.response.status === 404) {
                    displayAlert("error", "Unexpected Error", "Email address not found. Please register instead.");
                    Mixpanel.track("UI Forgot Password Email - failed email not found");
                }
                else {
                    displayAlert("error", "Unexpected Error", "Please try again later");
                    Mixpanel.track("UI Forgot Password Email - failed API error");
                }
                setIsProcessing(false);
            },
            onSuccess: (data) => {
                displayAlert("success", "Success", "Please check your email and click the link provided");
                Mixpanel.track("UI Forgot Password Email - successful");
                setEmailSent(true);
                setIsProcessing(false);
                return;
            },
        });
    }, 500, { trailing: false });

    const layoutContainerClassName = classNames(
        "layout-wrapper ",
        "pages-body",
        "login-page",
        "flex",
        "flex-column",
        "layout-menu-cyan layout-topbar-cyan",
        {
            "layout-topbar-mobile-active": mobileTopbarActive,
            "p-input-outlined": "outlined",
        }
    );

    useEffect(() => {
        if (TokenService.isLoggedIn()) {
            navigate("/account/select-provider");
            return;
        }
        // Mixpanel.track_links();
        // grab code from the URL
        var _code = searchParams.get("code");
        if (_code && _code !== "") {
            setCode(_code);
            setCodeVerified(true);
            setEmailSent(true);
        }
    }, []);

    return (
        <div className={layoutContainerClassName}>
            <MainMenu />
            <div className="align-self-center mt-auto mb-auto">
                <div className="pages-panel card flex flex-column">
                    <div className="pages-header mb-6 px-3 py-1">
                        <h2>Forgot Password</h2>
                    </div>
                    {!emailSent && (
                        <>
                            <div className="pages-detail mb-6 px-3" style={{ maxWidth: "400px" }}>Please enter your email address and we will send you a unique link to reset your password.</div>
                            <form className="form" onSubmit={onEmailSubmit}>
                                <div className="input-panel flex flex-column px-3 mb-6">
                                    <div className="p-inputgroup">
                                        <span className="p-float-label">
                                            <InputText
                                                type="text"
                                                id="email"
                                                name="email"
                                                value={values.email}
                                                onChange={handleChange}
                                                autoFocus
                                            />
                                            <label htmlFor="email">Email Address</label>
                                        </span>
                                    </div>
                                </div>
                                <div className="grid text-center mt-1">
                                    <div className="col white-space-nowrap">
                                        <Button
                                            className="login-button mb-3 px-6"
                                            label="Continue"
                                            icon="pi pi-check"
                                            type="submit"
                                            disabled={!changesMadeEmail || isProcessing}
                                            loading={isProcessing}
                                        ></Button>
                                    </div>
                                </div>
                            </form>
                        </>
                    )}
                    {emailSent && !codeVerified && (
                        <>
                            <div className="pages-detail mb-4 px-3" style={{ maxWidth: "400px" }}>We sent a recovery link to your email. Please click on the link in the email to set your new password.</div>
                            <div className="pages-detail mb-4 px-3 font-bold" style={{ maxWidth: "400px" }}>{values.email}</div>
                            <form className="form" onSubmit={onEmailSubmit}>
                                <div className="grid text-center mt-1">
                                    <div className="col white-space-nowrap">
                                        <Button
                                            className="login-button mb-3 px-6"
                                            label="Resend Code"
                                            icon="pi pi-check"
                                            type="submit"
                                            disabled={isProcessing}
                                            loading={isProcessing}
                                        ></Button>
                                    </div>
                                </div>
                            </form>
                        </>
                    )}
                    {emailSent && codeVerified && (
                        <>
                            <div className="pages-detail mb-3 px-3" style={{ maxWidth: "400px" }}>Please enter your new password.</div>
                            <form className="form" onSubmit={onResetPasswordSubmit}>
                                <div className="input-panel flex flex-column px-3 mb-3">
                                    <div className="p-inputgroup mt-1 sm:mt-3">
                                        <span className="p-float-label">
                                            <Password
                                                inputId="password"
                                                value={inputPassword}
                                                onChange={handlePasswordChange}
                                                feedback={false}
                                                toggleMask
                                            />
                                            <label htmlFor="password">Password</label>
                                        </span>
                                    </div>
                                    <p className="mt-2 sm:mt-3 mb-0">Password Requirements:</p>
                                    <div className="">
                                        <div>
                                            {changesMadePassword && pwdLenghtMet && (<i className="pi pi-check mr-2 text-green-400"></i>)}
                                            {changesMadePassword && !pwdLenghtMet && (<i className="pi pi-times mr-2 text-pink-400"></i>)}
                                            {!changesMadePassword && (<i className="pi pi-minus mr-2"></i>)}
                                            Minimum 12 characters
                                        </div>
                                        <div>
                                            {changesMadePassword && pwdLowercaseMet && (<i className="pi pi-check mr-2 text-green-400"></i>)}
                                            {changesMadePassword && !pwdLowercaseMet && (<i className="pi pi-times mr-2 text-pink-400"></i>)}
                                            {!changesMadePassword && (<i className="pi pi-minus mr-2"></i>)}
                                            At least one lowercase
                                        </div>
                                        <div>
                                            {changesMadePassword && pwdUppercaseMet && (<i className="pi pi-check mr-2 text-green-400"></i>)}
                                            {changesMadePassword && !pwdUppercaseMet && (<i className="pi pi-times mr-2 text-pink-400"></i>)}
                                            {!changesMadePassword && (<i className="pi pi-minus mr-2"></i>)}
                                            At least one uppercase
                                        </div>
                                        <div>
                                            {changesMadePassword && pwdNumberMet && (<i className="pi pi-check mr-2 text-green-400"></i>)}
                                            {changesMadePassword && !pwdNumberMet && (<i className="pi pi-times mr-2 text-pink-400"></i>)}
                                            {!changesMadePassword && (<i className="pi pi-minus mr-2"></i>)}
                                            At least one number
                                        </div>
                                        <div>
                                            {changesMadePassword && pwdSpecialMet && (<i className="pi pi-check mr-2 text-green-400"></i>)}
                                            {changesMadePassword && !pwdSpecialMet && (<i className="pi pi-times mr-2 text-pink-400"></i>)}
                                            {!changesMadePassword && (<i className="pi pi-minus mr-2"></i>)}
                                            At least one special character
                                        </div>
                                    </div>
                                    <div className="text-center mt-1">
                                        <div className="col white-space-nowrap">
                                            <Button
                                                className="login-button mb-3 px-6"
                                                label="Reset Password"
                                                icon="pi pi-check"
                                                type="submit"
                                                disabled={!changesMadePassword || isProcessing}
                                                loading={isProcessing}
                                            ></Button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </>
                    )}
                    <div>
                        <span>
                            <a href={process.env.REACT_APP_ID_SITE + "/register"}>Create Account</a>
                        </span>
                        <span className="px-3">|</span>
                        <span>
                            <a href={process.env.REACT_APP_ID_SITE + "/login"}>Login</a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
